import { Order } from 'models/Order';
import { v4 as uuidv4 } from 'uuid';
import { Feedback } from '../models/Feedback';
import { Word } from '../models/Word';
import { getFile } from '../providers/Firebase';
import { feedbackCollection, wordCollection } from '../providers/Firestore';
import { demoStorage } from '../providers/Storage';

class WordService {

  async getWords(sortBy = 'text', order = Order.ASC) {
    const query = await wordCollection.orderBy(sortBy, order).get()
    const words = query.docs.map(doc =>
      Object.assign(new Word(), { key: doc.id, ...doc.data() })
    )

    return words
  }

  async getWordById(id: string) {
    const doc = await wordCollection.doc(id).get()

    return (Object.assign(new Word(), { key: doc.id, ...doc.data() }))
  }

  // @TODO Paginar busca
  async getWordsBySinal(id: string) {
    const qFirstHand = wordCollection.where('signalLeft', '==', id)
    const qSecondHand = wordCollection.where('signalRight', '==', id)

    const rFirstHand = await qFirstHand.get()
    const rSecondHand = await qSecondHand.get()

    // Remove duplicated
    const items = new Set([
      rFirstHand.docs.map(doc =>
        Object.assign(new Word(), { key: doc.id, ...doc.data() })
      ),
      rSecondHand.docs.map(doc =>
        Object.assign(new Word(), { key: doc.id, ...doc.data() })
      )
    ].flat())

    return Array.from(items)
  }

  // @TODO Paginar busca
  async getWordsByTag(tag: string) {
    const req = wordCollection.where('tags', 'array-contains', tag).get()
    const res = await req;

    const words = res.docs.map(doc =>
      Object.assign(new Word(), { key: doc.id, ...doc.data() })
    )

    return words
  }

  // @TODO Paginar busca
  searchWord(term: string) {
    return wordCollection.where('nome', '==', term).get()
  }

  async saveWord(word: Word) {
    const newDoc = wordCollection.doc()

    word.key = newDoc.id

    await newDoc.set({ ...word })

    return word.key
  }

  async saveFeedback(feedback: Feedback) {
    const newDoc = feedbackCollection.doc()

    feedback.key = newDoc.id

    await newDoc.set({ ...feedback })

    return feedback.key
  }

  async getFeedBacks(wordId: string) {
    const query = await feedbackCollection.where('wordKey', '==', wordId).get()
    const feedbacks = query.docs.map(doc =>
      Object.assign(new Feedback(), { key: doc.id, ...doc.data() })
    )

    return feedbacks
  }

  async uploadVideo(file: File) {
    const uuid = uuidv4()
    const ext = file.name.split('.')[1]
    const ref = demoStorage().child(`${uuid}.${ext}`)

    await ref.put(file);

    return ref
  }

  getFileStorage(path: string) {
    return getFile(path)
  }
}

export default new WordService();
